module.exports = __webpack_public_path__ + "static/media/trump6.17bcce7c.jpg";